import { careerItems } from "@/mocks/home";

const formerExperience = careerItems.formerExperience;
const currentExperience = careerItems.currentExperience;

export default function AboutCareerSection() {
  return (
    <section className="bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-16 max-w-[1400px] mx-auto pt-36 md:pt-32 lg:pt-28 pb-12 md:pb-16">
        {/* Identity */}
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="shrink-0">
            <div className="relative">
              <img
                src="/images/pro_g.jpg"
                alt="이승환 변호사"
                className="w-[260px] md:w-[320px] lg:w-[360px] h-auto rounded-2xl object-cover"
              />
              <div className="absolute -bottom-3 -right-3 w-full h-full rounded-2xl border-2 border-primary-200 -z-10" />
              <div className="absolute -bottom-5 -left-5 md:-left-7 flex items-center gap-2.5 px-4 py-3 rounded-xl bg-primary-900">
                <span className="w-8 h-8 rounded-lg bg-accent-500/20 flex items-center justify-center shrink-0">
                  <i className="ri-scales-3-line text-accent-400 text-sm" />
                </span>
                <span className="text-white text-xs md:text-sm font-medium whitespace-nowrap">
                  부동산·형사전문변호사
                </span>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full">
            <p className="text-accent-500 text-sm font-medium tracking-widest mb-2">ABOUT</p>
            <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
              부동산·형사전문
              <span className="block md:mt-2">
                <span className="text-primary-500">이승환</span> 변호사
              </span>
            </h2>

            <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-xl mb-8">
              법무법인 효민 이승환 변호사는 부동산·형사사건을 중심으로, 모든 사건을 성실히 수행하는 변호사입니다.
              탄탄한 전문성과 매년 다수의 무죄·승소로 의뢰인의 권익을 지켜내고 있습니다.
            </p>

            <div className="flex flex-wrap items-center gap-4">
              <a
                href="#media"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 hover:bg-background-200 text-foreground-700 font-medium rounded-md transition-colors border border-background-200 whitespace-nowrap text-sm"
              >
                <i className="ri-movie-line" />
                <span>방송출연 및 언론보도</span>
              </a>
            </div>
          </div>
        </div>

        {/* Career — refined timeline layout */}
        <div className="mt-16 md:mt-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
            <div>
              <div className="flex items-center gap-3 pb-6 border-b border-background-200 mb-8">
                <span className="w-1.5 h-1.5 rounded-full bg-foreground-300" />
                <span className="font-display text-lg md:text-xl font-semibold text-foreground-900">전직</span>
                <span className="text-[11px] tracking-[0.25em] text-foreground-400 ml-auto">FORMER</span>
              </div>
              <ul className="relative">
                <span className="absolute left-[3.5px] top-3 bottom-3 w-px bg-background-200" aria-hidden="true" />
                {formerExperience.map((item, idx) => (
                  <li key={idx} className="relative flex gap-5 pb-7 last:pb-0">
                    <span className="relative z-10 w-2 h-2 rounded-full bg-foreground-300 mt-2 shrink-0" />
                    <span className="text-sm md:text-[15px] text-foreground-700 leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <div className="flex items-center gap-3 pb-6 border-b border-background-200 mb-8">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
                <span className="font-display text-lg md:text-xl font-semibold text-foreground-900">현직</span>
                <span className="text-[11px] tracking-[0.25em] text-foreground-400 ml-auto">CURRENT</span>
              </div>
              <ul className="relative">
                <span className="absolute left-[3.5px] top-3 bottom-3 w-px bg-background-200" aria-hidden="true" />
                {currentExperience.map((item, idx) => (
                  <li key={idx} className="relative flex gap-5 pb-7 last:pb-0">
                    <span className="relative z-10 w-2 h-2 rounded-full bg-accent-500 mt-2 shrink-0" />
                    <span className="text-sm md:text-[15px] text-foreground-700 leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}